import React, { useState, useEffect } from "react";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import useTable from "../useTableR";
import axios from "axios";
import { Toasts } from "../toasts";
import ModalTipologia from "./modalTipologia";
//UI
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

function TablaTipologia(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [operacion, setOperacion] = useState();
  const [tipologia, setTipologia] = useState();
  const permiso = JSON.parse(localStorage.getItem("accvalortipocat"));
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells = [
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ID",
      textAlign: "center",
    },
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO TIPOLÓGIA",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "left",
    },
  
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "OPCIONES",
      textAlign: "center",
    },
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.codtipologia.includes(target.value) === null
                ? ""
                : x.codtipologia.includes(target.value)) ||
              (x.idtipologia === null
                ? ""
                : x.idtipologia
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.descripcion === null
                ? ""
                : x.descripcion
                    .toLowerCase()
                    .includes(target.value.toLowerCase()))
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "tipologia";
    let orden = "idtipologia asc";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarRegistro = (id) => {
    let campos =
      "idtipologia,codtipologia,trim(descripcion) as descripcion,valortipo";
    let nomtab = "tipologia";
    let nomid = "idtipologia";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data !== "") {
            setTipologia(response.data);
            setActivate(false);
            setMostrar(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarTipologia = (op, id, per) => (e) => {
    e.preventDefault();
    setOperacion(op);
    if (per === "1") {
      if (op !== 1) {
        seleccionarRegistro(id);
      } else {
        setMostrar(true);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
            ? "No posee permiso para Editar"
            : op === 3
            ? "No posee permiso para Eliminar"
            : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };
  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 rounded d-flex flex-column justify-content-center"
    style={{ minHeight: '85vh' }}>
      <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between text-light border-bottom">
      <h3 className="fw-bold text-light m-0">
              Valoracion de la contruccion
            </h3>
            <button onClick={cerrar} className="btn btn-sm bg-light">
            <i className="fa fa-times" />
            </button>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
            <div className="col-4 m-0 p-0">
            <SearchInput
                placeholder="Buscar"
                onChange={handleSearch}
            />
            </div>
            <div className="col-auto m-0 p-0">
            <PrimaryButton icon = 'fa-plus m-0'
                onClick={seleccionarTipologia(
                1,
                "",
                permiso.toString().substring(0, 1)
                )}
                disable = {!permiso.toString().substring(0, 1) === "1"}
                title="Agregar Contribuyente"
            />
            </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idtipologia} style={{ padding: "0" }}>
                     <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: '50px' }}
                    >
                      {item.idtipologia}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: '150px' }}
                    >
                      {item.codtipologia}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "left", width: 'auto' }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="align-baseline"
                      align="center"
                      style={{ textAlign: "right",width: '150px' }}
                    >
                      <button
                        onClick={seleccionarTipologia(
                          4,
                          item.idtipologia,
                          permiso.toString().substring(0, 1)
                        )}
                        title="Consultar Contribuyente"
                        className={
                          permiso.toString().substring(0, 1) === "1"
                            ? "btn btn-sm btn-info rounded-pill"
                            : "btn btn-sm btn-secondary rounded-pill"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={seleccionarTipologia(
                          2,
                          item.idtipologia,
                          permiso.toString().substring(2, 3)
                        )}
                        title="Editar Con"
                        className={
                          permiso.toString().substring(2, 3) === "1"
                            ? "btn btn-sm btn-warning rounded-pill"
                            : "btn btn-sm btn-secondary rounded-pill"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={seleccionarTipologia(
                          3,
                          item.idtipologia,
                          permiso.toString().substring(3, 4)
                        )}
                        className={
                          permiso.toString().substring(3, 4) === "1"
                            ? "btn btn-sm btn-danger rounded-pill"
                            : "btn btn-sm btn-secondary rounded-pill"
                        }
                      >
                        <i className="fa fa-trash-alt"></i>{" "}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ModalTipologia
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
        operacion={operacion}
        tipologia={tipologia}
        onHideRender={seleccionarRegistros}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}

export default TablaTipologia;
